<template>
  <div class="loading-screen level-center is-mobile">
    <div class="loader"></div>
    <p class="">Loading...</p>
  </div>
</template>

<style lang="scss" scoped>
@use "../styles/variables";
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: variables.$black-transparent;
  z-index: 10;
  p {
    color: white;
  }
}
</style>
